export default "__VITE_ASSET__qvSy5AIK__"